import { useEffect, useMemo, useState } from 'react'
import moment from 'moment'
import DropDownOA from '../../common/dropDownOA'
import { Item } from '../../common/snippets'
import { Box, Button, Stack, Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material'
import Datepicker from '../../common/datePicker'
import * as sx from '../../common/stylesInline/report_daily_branch'
import InfoCard from './InfoCard'
import { bookingOverview, deliveryOverview, statusOverview, branchMonthlyBooking } from './constants'
import CustomPieChart from '../../common/charts/customPieChart'
import CustomBarChart from '../../common/charts/customBarChart'
import { CustomLegend } from '../../common/charts/snippets'
import {
  appendToUrl,
  generateContrastingColors,
  getLocalStorage,
  paymentColors,
  removeLocalStorage,
  setLocalStorage,
} from '../../common/helper'
import SlidingToggle from '../../common/SlidingToggle'
import { TableContainer, Typography } from '@mui/material'
import { paymentModes } from '../../common/paymentsMode'
import { API_CACHE_DURATION, businessAnalysis, monthList, urls } from '../../common/constants'
import * as urls2 from './constants'
import { getOwnChildBranchesAtoms, ownChildBranchesAtoms } from '../../common/jotaiState/dashboardStateAtoms'
import { useAtom } from 'jotai'
import useToken from '../../helpers/useTokens'
import { GetRequestCachedV3, PostRequestCachedV3 } from '../../common/api'
import { RefreshSvg } from '../../common/svg/refresh'
import { alertAtom, globalLoaderAtom, modalAtom } from '../../common/jotaiState/globalStateAtoms'
import Modal from '../../common/modal'
import { GUJRAT_COMPANY_ID } from '../../../helper/companyIdhardcode'
import { useSearchParams } from 'react-router-dom'
import { decryptText } from '../../common/loginDecode'
import { CargoRoleRightsAtom } from '../../common/jotaiState/commonStateAtoms'
import { ChildCompanyListData, fetchChildCompanyListData } from '../../common/jotaiState/reportStateAtom'
export const DashBoard = () => {
  const [searchParams, setSearchParams] = useSearchParams()
  let loginData = {}
  const { loginData: loginDataTemp } = useToken()
  if (searchParams.get('data')) {
    const data = searchParams.get('data')
    const loginDataTemp = data.split('||')
    const decryptData = decryptText(loginDataTemp[0])
    if (decryptData) {
      loginData = JSON.parse(decryptData)
      loginData.BusCrsCheckSum = loginDataTemp[1]
    }
  } else {
    loginData = loginDataTemp
  }
  const { intCompanyID, intBranchID, intUserID, BusCrsCheckSum, strCompanyName } = loginData
  const [selectCompany, setSelectedCompany] = useState({})
  const [branches, setBranches] = useState([])
  const [branch, setBranch] = useState({})
  const [userList, setUserList] = useState([])
  const [, fetchChildCompanyList] = useAtom(fetchChildCompanyListData)
  const [ChildCompanyList] = useAtom(ChildCompanyListData)

  const [selectedUser, setSelectedUser] = useState()
  const [fromDate, setFromDate] = useState(moment().format('YYYY-MM-DD'))
  const [toDate, setToDate] = useState(moment().format('YYYY-MM-DD'))
  const [pieButton, setPieButton] = useState(1)
  const [pieChartData, setPieChartData] = useState([])
  const [paymentWiseBookingData, setPaymentWiseBookingData] = useState([])
  const [paymentWiseDeliveryData, setPaymentWiseDeliveryData] = useState([])
  const [paymentWiseDeliveryCount, setPaymentWiseDeliveryCount] = useState([])
  const [topCityButton, setTopCityButton] = useState(1)
  const [topBookingCityData, setTopBookingCityData] = useState([])
  const [topDeliveryCityData, setTopDeliveryCityData] = useState([])
  const [topBranchButton, setTopBranchButton] = useState(1)
  const [topBookingBranchData, setTopBookingBranchData] = useState([])
  const [topDeliveryBranchData, setTopDeliveryBranchData] = useState([])
  const [branchwiseMonthlyBookingData, setBranchwiseMonthlyBookingData] = useState([])
  const [partywiseSenderRevenueData, setPartywiseSenderRevenueData] = useState([])
  const [partywiseReceiverRevenueData, setPartywiseReceiverRevenueData] = useState([])
  const [branchRevenueMonth, setBranchRevenueMonth] = useState({})
  const [partyRevenueMonth, setPartyRevenueMonth] = useState({})
  const [partySenderBookingData, setPartySenderBookingData] = useState([])
  const [partyReceiverBookingData, setPartyReceiverBookingData] = useState([])
  const [partyAllBookingData, setPartyAllBookingData] = useState([])
  const [pending7DaysData, setPending7DaysData] = useState([])
  const [pending30DaysData, setPending30DaysData] = useState([])
  const [branchSetByInit, setBranchSetByInit] = useState(false)
  const [statusOverviewValue, setStatusOverviewValue] = useState({})
  const [modal, setModal] = useAtom(modalAtom)
  const [, setAlert] = useAtom(alertAtom)
  const [, setLoader] = useAtom(globalLoaderAtom)
  const monthListData = useMemo(() => monthList(), [])
  const [roleRights] = useAtom(CargoRoleRightsAtom)
  const RoleRights = roleRights?.Table1?.[0] || {}
  const { DashboardAccessLevel } = RoleRights || {}
  //const DashboardAccessLevel = 5
  const [revenueByOriginData, setRevenueByOriginData] = useState([])
  const [revenueByDestinationData, setRevenueByDestinationData] = useState([])
  const [userNoOfParcelData, setUserNoOfParcelData] = useState([])
  const [userAllTotalData, setUserAllTotalData] = useState([])
  const [dateWiseRevenueData, setDateWiseRevenueData] = useState([])
  const [dateWiseNoOfParcelData, setDateWiseNoOfParcelData] = useState([])
  const [revenuePerHourData, setRevenuePerHourData] = useState([])
  const [parcelPerHourData, setParcelPerHourData] = useState([])
  const userData = {
    intCompanyID: selectCompany?.CompanyID,
    intBranchId: branch?.BranchID || 0,
    intUserID,
    SelectBranchName: branch?.BranchName,
  }
  useEffect(() => {
    if (intCompanyID) {
      const companyList = [{ CompanyID: intCompanyID, CompanyName: strCompanyName }]
      setSelectedCompany(companyList[0])
      const body = {
        intCompanyID: intCompanyID,
        UserID: intUserID,
      }
      fetchChildCompanyList(body)
    }
  }, [intCompanyID])
  useEffect(() => {
    if (selectCompany?.CompanyID) {
      fetchOwnChildBranches({
        intUserID: 0,
        intCompanyID: selectCompany?.CompanyID,
        intIsActive: 1,
      })
    }
  }, [selectCompany])
  useEffect(() => {
    if (branch?.BranchID) {
      getUserList(branch.BranchID, selectCompany?.CompanyID || 0)
    }
  }, [branch])
  useEffect(() => {
    if (monthListData.length > 0) {
      setPartyRevenueMonth(monthListData[0])
      setBranchRevenueMonth(monthListData[0])
    }
  }, [monthListData])
  useEffect(() => {
    if (branches?.length > 0) {
      const loginBranch = branches?.filter((item) => item.BranchID === intBranchID)
      setBranch(loginBranch?.[0])
      setBranchSetByInit(true)
    }
  }, [branches])
  useEffect(() => {
    if (branchSetByInit && branch?.BranchID) {
      getdata1(true)
      getdata2(true)
      getData4(true)
      setBranchSetByInit(false)
    }
  }, [branchSetByInit, branch])

  const fetchOwnChildBranches = (data) => {
    setLoader(true)
    GetRequestCachedV3(urls.getOwnAndChildBranchList, data, true, API_CACHE_DURATION)
      .then((res) => {
        if (res.status !== 'Success') {
          throw new Error(res?.ErrMessage || 'Request Failed')
        }
        if (!Array.isArray(res.Data.Table) || res.Data.Table.length === 0) {
          throw new Error('No Data Found')
        }
        const branchlist = [{ BranchID: 0, BranchName: 'All Branches' }, ...res.Data.Table.filter((a) => a.CompanyID === selectCompany?.CompanyID)]
        setBranches(branchlist)
        setBranch(branchlist.find((a) => a.BranchID === intBranchID) || branchlist[0])
      })
      .catch((err) => {
        setAlert({ show: true, msg: err.message, nextId: '' })
      })
      .finally(() => setLoader(false))
  }
  const getUserList = (intBranchID, intCompanyID) => {
    let userBody = {
      intUserID: 0,
      intCompanyID,
      intBranchID,
      strUserName: '',
      strLoginID: '',
      strPassword: '',
      strContactNo: '',
      intRoleID: 0,
      intIsActive: 1,
    }
    setLoader(true)
    PostRequestCachedV3(urls.getUserList, userBody, true, API_CACHE_DURATION)
      .then((res) => {
        if (res.status !== 'Success' || !Array.isArray(res?.Data?.Table)) {
          throw new Error(res?.ErrMessage || 'Invalid Response')
        }

        if (!res.Data.Table.length) {
          throw new Error('No Data Found')
        }
        const list = res.Data.Table
        setUserList(DashboardAccessLevel > 0 ? [{ UserName: "All Users", UserID: 0 }, ...list] : list)
        const defaultUser = DashboardAccessLevel > 0 ? { UserName: "All Users", UserID: 0 } : list.find((a) => a.UserID === intUserID) || list[0]
        setSelectedUser(defaultUser)
      })
      .catch((err) => {
        setUserList([])
        setSelectedUser({ UserName: 'SELECT' })
        setAlert({
          show: true,
          msg: err.message,
          nextId: '',
        })
      })
      .finally(() => {
        setLoader(false)
      })
  }
  const getdata1 = async (fromCache = false) => {
    const nonmovementPayload = {
      intCompanyID: selectCompany?.CompanyID,
      intBranchID: branch.BranchID,
      FromDate: fromDate,
      ToDate: toDate,
      UserID: selectedUser?.UserID || 0,
      DashboardAccessLevel: DashboardAccessLevel,
    }
    const bkgdelPayload = { ...nonmovementPayload, intCityID: branch?.BranchID === 0 ? 0 : branch?.CityID }
    let nonmovementRes = {}
    let bookingdelvRes = {}
    const nonmovement = () => GetRequestCachedV3(urls.dashBoardCargoNonMovedDetails, nonmovementPayload, true, API_CACHE_DURATION)
    const bookingdelv = () => GetRequestCachedV3(urls.dashboardPreprocessBkgDel, bkgdelPayload, true, API_CACHE_DURATION)
    if (fromCache) {
      nonmovementRes = getLocalStorage('dbnonmovementData')
      bookingdelvRes = getLocalStorage('dbbookingdelv')
      if (!nonmovementRes) {
        setLoader(true)
        const res = await Promise.allSettled([nonmovement(), bookingdelv()])
        setLoader(false)
        if (res[0].value) {
          if (res[0].value?.status === 'Success') {
            nonmovementRes = res[0].value
            setLocalStorage('dbnonmovementData', res[0].value, API_CACHE_DURATION)
          } else {
            setAlert({ show: true, msg: res[0].value?.ErrMessage })
          }
        }
        if (res[1].value) {
          if (res[1].value?.status === 'Success' || res[1].value?.status === true) {
            bookingdelvRes = res[1].value
            setLocalStorage('dbbookingdelv', res[1].value, API_CACHE_DURATION)
          } else {
            setAlert({ show: true, msg: res[1].value?.ErrMessage })
          }
        }
      }
    } else {
      setLoader(true)
      const res = await Promise.allSettled([nonmovement(), bookingdelv()])
      setLoader(false)
      if (res[0].value?.status === 'Success') {
        nonmovementRes = res[0].value
      } else {
        setAlert({ show: true, msg: res[0].value?.ErrMessage })
      }

      if (res[1].value?.status === 'Success' || res[1].value?.status === true) {
        bookingdelvRes = res[1].value
      } else {
        setAlert({ show: true, msg: res[1].value?.Message })
      }
    }
    const bookingData = bookingdelvRes?.Data || {}
    const nonmovementData = nonmovementRes?.Data || {}
    const nonmovementDataList = nonmovementData?.table1 || []
    const bd = bookingData?.BranchBookingData1?.[0] || {}
    const statusOverview = {
      ...bd,
      ...nonmovementData?.table?.[0],
    }
    setStatusOverviewValue(statusOverview)
    const pieVal = {
      1: bd?.PaidBookingNetAmount || 0,
      2: bd?.ToPayBookingNetAmount || 0,
      3: bd?.FOCBookingNetAmount || 0,
      4: bd?.CODBookingNetAmount || 0,
      5: bd?.OnAccountBookingNetAmount || 0,
      6: bd?.PaidManualBookingNetAmount || 0,
      7: bd?.ToPayManualBookingNetAmount || 0,
      8: bd?.SelfBookingNetAmount || 0,
      9: bd?.ToPayDDDVBookingNetAmount || 0,
      10: bd?.OnAccountManualBookingNetAmount || 0,
    }
    const paymentwisebookingData = paymentModes
      .map((item) => ({
        color: paymentColors[item.typeId],
        value: pieVal[item.typeId],
        name: item.type,
        active: true,
      }))
      .filter((item) => item.value)
    setPaymentWiseBookingData(paymentwisebookingData)
    setPieChartData(paymentwisebookingData)
    const pieVal2 = {
      1: bd?.PaidDeliveryNetAmount || 0,
      2: bd?.ToPayDeliveryNetAmount || 0,
      3: bd?.FOCDeliveryNetAmount || 0,
      4: bd?.CODDeliveryNetAmount || 0,
      5: bd?.OnAccountDeliveryNetAmount || 0,
      6: bd?.PaidManualDeliveryNetAmount || 0,
      7: bd?.ToPayManualDeliveryNetAmount || 0,
      8: bd?.SelfDeliveryNetAmount || 0,
      9: bd?.ToPayDDDVDeliveryNetAmount || 0,
      10: bd?.OnAccountManualDeliveryNetAmount || 0,
    }
    const paymentwiseDeliveryData = paymentModes
      .map((item) => ({
        color: paymentColors[item.typeId],
        value: pieVal2[item.typeId],
        name: item.type,
        active: true,
      }))
      .filter((item) => item.value)
    setPaymentWiseDeliveryData(paymentwiseDeliveryData)
    const countVal = {
      1: bd?.PaidDeliveryCount,
      2: bd?.ToPayDeliveryCount,
      3: bd?.FOCDeliveryCount || 0,
      4: bd?.CODDeliveryCount || 0,
      5: bd?.OnAccountDeliveryCount,
      6: bd?.PaidManualDeliveryCount,
      7: bd?.ToPayManualDeliveryCount,
      8: bd?.SelfDeliveryCount,
      9: bd?.ToPayDDDVDeliveryCount || 0,
      10: bd?.OnAccountManualDeliveryCount || 0,
    }
    const paymentwiseDeliveryCount = paymentModes
      .map((item) => ({
        PaymentType: item.name,
        LRCount: countVal[item.typeId],
      }))
      .filter((item) => item.LRCount)
    setPaymentWiseDeliveryCount([...paymentwiseDeliveryCount, { PaymentType: 'Total', LRCount: bd?.TotalDeliveryCount, isTotal: true }])

    const topBookingCityData = bookingData?.CityBkgData1 || []
    const topDeliveryCityData = bookingData?.CityDesData1 || []
    const topBookingBranchData = bookingData?.BranchBkgData1 || []
    const topDeliveryBranchData = bookingData?.BranchDesData1 || []
    const tableData = bookingData?.DashBoardMonthlyTargetDetails2 || []
    setTopBookingCityData(
      topBookingCityData
        .map((item) => ({
          CityID: item.CityID,
          name: item.CityName,
          netAmount: item.TotalBookingNetAmount,
          numberOfLrs: item.TotalBookings,
        }))
        .filter((item) => item.numberOfLrs || item.netAmount)
        .sort((a, b) => b.netAmount - a.netAmount) || []
    )
    setTopDeliveryCityData(
      topDeliveryCityData
        .map((item) => ({
          CityID: item.CityID,
          name: item.CityName,
          netAmount: item.ToPayDeliveryNetAmount,
          numberOfLrs: item.TotalDeliveryCount,
        }))
        .filter((item) => item.numberOfLrs || item.netAmount)
        .sort((a, b) => b.netAmount - a.netAmount) || []
    )
    setTopBookingBranchData(
      topBookingBranchData
        .map((item) => ({
          BranchID: item.BranchID,
          name: item.BranchName,
          netAmount: item.TotalBookingNetAmount,
          numberOfLrs: item.TotalBookings,
        }))
        .filter((item) => item.numberOfLrs || item.netAmount)
        .sort((a, b) => b.netAmount - a.netAmount) || []
    )
    setTopDeliveryBranchData(
      topDeliveryBranchData
        .map((item) => ({
          BranchID: item.BranchID,
          name: item.BranchName,
          netAmount: item.TotalDeliveryNetAmount,
          numberOfLrs: item.TotalDeliveryCount,
        }))
        .filter((item) => item.numberOfLrs || item.netAmount)
        .sort((a, b) => b.netAmount - a.netAmount) || []
    )
    setBranchwiseMonthlyBookingData(
      tableData.map((a, i) => ({
        ...a,
        Target: a.Target + '%',
        rank: i + 1,
      }))
    )
    setPending7DaysData(
      nonmovementDataList
        .filter((a) => a.SevenPendingDispatch || a.SevenPendingDelivery || a.SevenPendingReceipt)
        .map((a) => ({
          BranchID: a.BranchID,
          name: a.BranchName,
          pendingDispatch: a.SevenPendingDispatch,
          pendingDelivery: a.SevenPendingDelivery,
          pendingReceive: a.SevenPendingReceipt,
        }))
    )
    setPending30DaysData(
      nonmovementDataList
        .filter((a) => a.ThirtyPendingDispatch || a.ThirtyPendingDelivery || a.ThirtyPendingReceipt)
        .map((a) => ({
          BranchID: a.BranchID,
          name: a.BranchName,
          pendingDispatch: a.ThirtyPendingDispatch,
          pendingDelivery: a.ThirtyPendingDelivery,
          pendingReceive: a.ThirtyPendingReceipt,
        }))
    )
  }
  const getdata2 = async (fromCache = false, FromDate, ToDate) => {
    const now = new Date();
    if (!FromDate) {
      FromDate = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-01`
    }
    if (!ToDate) {
      const lastDay = new Date(now.getFullYear(), now.getMonth() + 1, 0);
      ToDate = `${lastDay.getFullYear()}-${String(lastDay.getMonth() + 1).padStart(2, '0')}-${String(lastDay.getDate()).padStart(2, '0')}`
    }
    const partydata = {
      intCompanyID: selectCompany?.CompanyID,
      FromDate: FromDate,
      ToDate: ToDate,
      UserID: selectedUser?.UserID || 0,
      DashboardAccessLevel: DashboardAccessLevel,
    }
    let partyRes = {}
    if (fromCache) {
      partyRes = getLocalStorage('dbpartyRes')
      if (!partyRes) {
        setLoader(true)
        const res = await GetRequestCachedV3(urls.dashBoardCargoPartyBreakup, {...partydata, BranchID: branch?.BranchID || 0}, true, API_CACHE_DURATION)
        setLoader(false)
        if (res?.status === 'Success') {
          partyRes = res
          setLocalStorage('dbpartyRes', res, API_CACHE_DURATION)
        } else {
          setAlert({ show: true, msg: res?.ErrMessage })
        }
      }
    } else {
      setLoader(true)
      partyRes = await GetRequestCachedV3(urls.dashBoardCargoPartyBreakup, {...partydata, BranchID: branch?.BranchID || 0}, true, API_CACHE_DURATION)
      setLoader(false)
    }
    if (partyRes?.status === 'Success') {
      const partyData = partyRes?.Data || {}
      const senderPartyData = partyData?.table || []
      const receiverPartyData = partyData?.table1 || []
      const allPartyData = partyData?.table2 || []
      const colors = generateContrastingColors(Math.min(senderPartyData.length, 20))
      const senderPartyList = senderPartyData
        .map((item, index) => ({
          name: item.SenderParty,
          value: item.NetAmount,
          active: true,
        }))
        .sort((a, b) => b.value - a.value)
        .slice(0, 20)
        .map((a, index) => ({ ...a, color: colors[index] }))
      setPartywiseSenderRevenueData(senderPartyList)
      const colors1 = generateContrastingColors(Math.min(receiverPartyData.length, 20))
      const receiverPartyList = receiverPartyData
        .map((item, index) => ({
          name: item.ReceiverParty,
          value: item.NetAmount,
          active: true,
        }))
        .sort((a, b) => b.value - a.value)
        .slice(0, 20)
        .map((a, index) => ({ ...a, color: colors1[index] }))
      setPartywiseReceiverRevenueData(receiverPartyList)
      const senderList = senderPartyData
        .map((item) => ({
          name: item.SenderParty,
          netAmount: item.NetAmount,
          numberOfLrs: item.LRcount,
          PartyID: item.PartyID,
        }))
        .filter((item) => item.numberOfLrs || item.netAmount)
      const receiverList = receiverPartyData
        .map((item) => ({
          name: item.ReceiverParty,
          netAmount: item.NetAmount,
          numberOfLrs: item.LRcount,
          PartyID: item.PartyID,
        }))
        .filter((item) => item.numberOfLrs || item.netAmount)
      setPartySenderBookingData(senderList.sort((a, b) => b.netAmount - a.netAmount))
      setPartyReceiverBookingData(receiverList.sort((a, b) => b.netAmount - a.netAmount))
      const partyAllBookingData = allPartyData
        .map((item) => ({
          name: item.PartyName,
          netAmount: item.NetAmount,
          numberOfLrs: item.LRcount,
          PartyID: item.PartyID,
        }))
        .filter((item) => item.numberOfLrs || item.netAmount)
        .sort((a, b) => b.netAmount - a.netAmount)
        .slice(0, 20)
        .map((item, index) => ({ ...item, rank: index + 1, business: `${item.netAmount} (${item.numberOfLrs} )` }))
      setPartyAllBookingData(partyAllBookingData)
    } else {
      setAlert({ show: true, msg: partyRes?.ErrMessage })
    }
  }
  const getData4 = async (fromCache = false) => {
    if(!branch?.BranchName) {
      setAlert({ show: true, msg: 'Please select branch to view data' })
      return
    }
    const bodyData = {
      intCompanyID: selectCompany?.CompanyID,
      BranchID: branch.BranchID,
      FromDate: fromDate,
      ToDate: toDate,
      UserID: selectedUser?.UserID || 0,
      DashboardAccessLevel: DashboardAccessLevel,
    }
    let tableData4 = {}
    if (fromCache) {
      tableData4 = getLocalStorage('dbpartyRes')
      if (!tableData4) {
        setLoader(true)
        const res = await GetRequestCachedV3(urls.GetCargoKenyaDashBoardData, bodyData, true, API_CACHE_DURATION)
        setLoader(false)
        if (res?.status === 'Success') {
          tableData4 = res
          setLocalStorage('dbpartyRes', res, API_CACHE_DURATION)
        } else {
          setAlert({ show: true, msg: res?.ErrMessage })
        }
      }
    } else {
      setLoader(true)
      tableData4 = await GetRequestCachedV3(urls.GetCargoKenyaDashBoardData, bodyData, true, API_CACHE_DURATION)
      setLoader(false)
    }
    if (tableData4?.status === 'Success') {
      const userData = tableData4?.Data || {}
      const revenueOriginData = userData?.table || []
      const revenueDestData = userData?.table1 || []
      const userNoParcelData = userData?.table2 || []
      const userTotalParcelData = userData?.table3 || []
      const dateWiseRevenue = userData?.table4 || []
      const dateWiseParcel = userData?.table5 || []
      const revenuePrHour = userData?.table6 || []
      const parcelPrHour = userData?.table7 || []
      const colors = generateContrastingColors(Math.min(revenueOriginData.length, 20))
      const revenueOriginList = revenueOriginData
        .map((item, index) => ({
          name: item.BookingCityName,
          value: item.TotalAmount,
          active: true,
        }))
        .sort((a, b) => b.value - a.value)
        .slice(0, 20)
        .map((a, index) => ({ ...a, color: colors[index] }))
      setRevenueByOriginData(revenueOriginList)
      const colors1 = generateContrastingColors(Math.min(revenueDestData.length, 20))
      const revenueDestList = revenueDestData
        .map((item, index) => ({
          name: item.DestinationCityName,
          value: item.TotalAmount,
          active: true,
        }))
        .sort((a, b) => b.value - a.value)
        .slice(0, 20)
        .map((a, index) => ({ ...a, color: colors1[index] }))
      setRevenueByDestinationData(revenueDestList)
      const colors3 = generateContrastingColors(Math.min(userNoParcelData.length, 20))
      const useNoParcelList = userNoParcelData
        .map((item, index) => ({
          name: item.UserName,
          value: item.TotalItems,
          active: true,
        }))
        .sort((a, b) => b.value - a.value)
        .slice(0, 20)
        .map((a, index) => ({ ...a, color: colors3[index] }))
      setUserNoOfParcelData(useNoParcelList)
      const colors4 = generateContrastingColors(Math.min(userTotalParcelData.length, 20))
      const userTotalParcelList = userTotalParcelData
        .map((item, index) => ({
          name: item.UserName,
          value: item.TotalAmount,
          active: true,
        }))
        .sort((a, b) => b.value - a.value)
        .slice(0, 20)
        .map((a, index) => ({ ...a, color: colors4[index] }))
      setUserAllTotalData(userTotalParcelList)
      setDateWiseRevenueData(
        dateWiseRevenue.map((a) => ({
          name: a.FormattedDate,
          dateWiseRevenueTotal: a.TotalAmount,
        }))
      )
      setDateWiseNoOfParcelData(
        dateWiseParcel.map((a) => ({
          name: a.FormattedDate,
          noOfParcel: a.TotalItems,
        }))
      )
      setRevenuePerHourData(
        revenuePrHour.map((a) => ({
          name: a.FormattedTime,
          revenuePerHour: a.TotalAmount,
        }))
      )
      setParcelPerHourData(
        parcelPrHour.map((a) => ({
          name: a.FormattedTime,
          parcelPerHour: a.TotalItems,
        }))
      )
    } else {
      setAlert({ show: true, msg: tableData4?.ErrMessage })
    }
  }
  const handleBranchMonthChange = async (selectedMonth) => {
    setBranchRevenueMonth(selectedMonth)
    const { monthVal, yearVal, day = 1 } = selectedMonth
    const bkgdelPayload = {
      intCompanyID: selectCompany?.CompanyID,
      intBranchID: 0,
      FromDate: `${yearVal}-${String(monthVal + 1).padStart(2, '0')}-${String(day).padStart(2, '0')}`,
      ToDate: `${yearVal}-${String(monthVal + 1).padStart(2, '0')}-${String(day).padStart(2, '0')}`,
      intCityID: 0,
    }
    setLoader(true)
    const res = await GetRequestCachedV3(urls.dashboardPreprocessBkgDel, bkgdelPayload, true, API_CACHE_DURATION)
    setLoader(false)
    const tableData = res?.Data?.DashBoardMonthlyTargetDetails2 || []
    setBranchwiseMonthlyBookingData(
      tableData.sort((a, b) => b.AchievementPercentage - a.AchievementPercentage).map((a, i) => ({
        ...a,
        Target: a.Target + '%',
        rank: i + 1,
        AchievementPercentage: Number(a.AchievementPercentage).toFixed(2) + '%',
      }))
    )
  }
  const handlePartyMonthChange = async (selectedMonth) => {
    setPartyRevenueMonth(selectedMonth)
    const { monthVal, yearVal, day = 1 } = selectedMonth
    const lastDayOfMonth = new Date(yearVal, monthVal + 1, 0).getDate()
    const FromDate = `${yearVal}-${String(monthVal + 1).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
    const ToDate = `${yearVal}-${String(monthVal + 1).padStart(2, '0')}-${String(lastDayOfMonth).padStart(2, '0')}`;
    getdata2(false,FromDate,ToDate)
  }
  const handleClick1 = () => {
    getdata1()
    getdata2(false)
    setPieButton(1)
    setTopCityButton(1)
    setTopBranchButton(1)
    getData4()
  }
  const refreshData = () => {
    removeLocalStorage('dbnonmovementData')
    removeLocalStorage('dbbookingdelv')
    removeLocalStorage('dbpartyRes')
    getdata1(true)
    getdata2(true)
    getData4(true)
    setPieButton(1)
    setTopCityButton(1)
    setTopBranchButton(1)
  }
  const PieTopSection = () => {
    return (
      <Item
        style={{
          display: 'flex',
          alignItems: 'flex-start',
          gap: '10px',
          flexDirection: 'column',
          justifyContent: 'space-between',
          padding: 0,
        }}
      >
        <Typography style={{ fontSize: '18px', color: '#000', fontWeight: 500 }}>Payment Type Breakup</Typography>
        <Box sx={{ width: '180px' }}>
          <SlidingToggle
            label1="Booking"
            label2="Delivery"
            externalActive={pieButton}
            onChange={(id) => {
              setPieButton(id)
              if (id === 2) setPieChartData(paymentWiseDeliveryData)
              else setPieChartData(paymentWiseBookingData)
            }}
          />
        </Box>
      </Item>
    )
  }
  const handleBookedLrs = () => {
    let url = urls2.bookedLRs
    let urlData = urls2.bookedLRParams
    urlData.FromDate = moment(fromDate).format('YYYY-MM-DD')
    urlData.ToDate = moment(toDate).format('YYYY-MM-DD')
    urlData.intBranchID = branch?.BranchID || 0
    urlData.chk = BusCrsCheckSum
    urlData.intCompanyId = selectCompany?.CompanyID
    url = appendToUrl(url, urlData)
    window.open(url, '_blank')
  }
  const handlePendingLRs = () => {
    let url = urls2.pendingLRs
    let urlData = urls2.commonPendingLRParams
    urlData = { ...urlData, ...userData }
    urlData.FromDate = moment(fromDate).format('YYYY-MM-DD')
    urlData.ToDate = moment(toDate).format('YYYY-MM-DD')
    urlData.StatusCode = 'All'
    urlData.Status = '--All--'
    urlData.chk = BusCrsCheckSum
    urlData.intCompanyId = selectCompany?.CompanyID
    url = appendToUrl(url, urlData)
    window.open(url, '_blank')
  }
  const handlePendingDispatchLRs = () => {
    let url = urls2.pendingLRs
    let urlData = urls2.commonPendingLRParams
    urlData = { ...urlData, ...userData }
    urlData.FromDate = moment(fromDate).format('YYYY-MM-DD')
    urlData.ToDate = moment(toDate).format('YYYY-MM-DD')
    urlData.StatusCode = 'B'
    urlData.Status = 'Booked But Pending Dispatch'
    urlData.chk = BusCrsCheckSum
    urlData.intCompanyId = selectCompany?.CompanyID
    url = appendToUrl(url, urlData)
    window.open(url, '_blank')
  }

  const handlePendingReceiveLRs = () => {
    let url = urls2.pendingLRs
    let urlData = urls2.commonPendingLRParams
    urlData = { ...urlData, ...userData }
    urlData.FromDate = moment(fromDate).format('YYYY-MM-DD')
    urlData.ToDate = moment(toDate).format('YYYY-MM-DD')
    urlData.StatusCode = 'D'
    urlData.Status = 'Dispatched But Pending Receive'
    urlData.chk = BusCrsCheckSum
    urlData.intCompanyId = selectCompany?.CompanyID
    url = appendToUrl(url, urlData)
    window.open(url, '_blank')
  }

  const handlePendingDeliveryLRs = () => {
    let url = urls2.pendingLRs
    let urlData = urls2.commonPendingLRParams
    urlData = { ...urlData, ...userData }
    urlData.FromDate = moment(fromDate).format('YYYY-MM-DD')
    urlData.ToDate = moment(toDate).format('YYYY-MM-DD')
    urlData.StatusCode = 'DR'
    urlData.Status = 'Recieved But Pending Delivery'
    urlData.chk = BusCrsCheckSum
    urlData.intCompanyId = selectCompany?.CompanyID
    url = appendToUrl(url, urlData)
    window.open(url, '_blank')
  }
  const handleSevenDaysPendingLRs = () => {
    let url = urls2.pendingLRs
    let urlData = urls2.commonPendingLRParams
    urlData = { ...urlData, ...userData }
    urlData.FromDate = moment(fromDate).format('YYYY-MM-DD')
    urlData.ToDate = moment(toDate).format('YYYY-MM-DD')
    urlData.StatusCode = 'All'
    urlData.Status = '--All--'
    urlData.intTimeNotMovedSince = 7
    urlData.chk = BusCrsCheckSum
    urlData.intCompanyId = selectCompany?.CompanyID
    url = appendToUrl(url, urlData)
    window.open(url, '_blank')
  }

  const handleThirtyDaysPendingLRs = () => {
    let url = urls2.pendingLRs
    let urlData = urls2.commonPendingLRParams
    urlData = { ...urlData, ...userData }
    urlData.FromDate = moment(fromDate).format('YYYY-MM-DD')
    urlData.ToDate = moment(toDate).format('YYYY-MM-DD')
    urlData.StatusCode = 'All'
    urlData.Status = '--All--'
    urlData.intTimeNotMovedSince = 30
    urlData.chk = BusCrsCheckSum
    url = appendToUrl(url, urlData)
    window.open(url, '_blank')
  }
  const handleDeliveryOverview = () => {
    setModal('deliveryOverview')
  }
  const handleMissingLRs = () => {
    console.log('handleMissingLRs')
  }
  const functionMap = {
    TotalBookingNetAmt: handleBookedLrs,
    PendingLRs: handlePendingLRs,
    TotalDeliveryNetAmount: handleDeliveryOverview,
    PendingDispatchLRs: handlePendingDispatchLRs,
    PendingReceiveLRs: handlePendingReceiveLRs,
    PendingDeliveryLRs: handlePendingDeliveryLRs,
    SevenDaysPendingLRs: handleSevenDaysPendingLRs,
    ThirtyDaysPendingLRs: handleThirtyDaysPendingLRs,
    TotalBookingLost: handleMissingLRs,
  }

  const handleBkngDelOverview = () => {
    let url = urls2.commonBkngDelOverviewUrl
    let urlData = urls2.commonBkngDelOverviewParams
    urlData.FromDate = moment(fromDate).format('YYYY-MM-DD')
    urlData.ToDate = moment(toDate).format('YYYY-MM-DD')
    urlData.BranchId = branch?.BranchID || 0
    urlData.BranchName = branch?.BranchName
    urlData.chk = BusCrsCheckSum
    url = appendToUrl(url, urlData)
    window.open(url, '_blank')
  }
  const handleBusinessAnalysis = () => {
    setSearchParams({ view: businessAnalysis })
  }
  return (
    <Item className="dashboard" sx={{ padding: '0' }}>
      <Item sx={{ padding: '0' }} className="dashboard-controls">
        <Box sx={sx.reportFlex} style={{ background: '#fff', borderBottom: '1px solid #ccc', paddingBottom: '10px' }}>
          <Item sx={{ ...sx.itemsx }} className="dashboard-branch">
            <DropDownOA
              id=""
              label={'Select Company'}
              data={ChildCompanyList}
              width="100%"
              defaultvalue={selectCompany?.CompanyName || ''}
              dataKey={'CompanyName'}
              idKey={'CompanyID'}
              listWidth={'280px'}
              disabled={DashboardAccessLevel < 5}
              onSelect={setSelectedCompany}
            />
          </Item>
          <Item sx={{ ...sx.itemsx }} className="dashboard-branch">
            <DropDownOA
              id="selectBranch"
              label={'Select Branch'}
              defaultvalue={branch?.BranchName || ''}
              onSelect={(val) => {
                setBranch(val)
              }}
              dataKey={'BranchName'}
              idKey={'BranchID'}
              data={branches}
              width="100%"
              listWidth={'280px'}
              disabled={DashboardAccessLevel < 2}
            />
          </Item>
          <Item sx={{ ...sx.itemsx }} className="dashboard-branch">
            <DropDownOA
              id=""
              label={'Select User'}
              data={userList}
              listWidth={'280px'}
              defaultvalue={selectedUser?.UserName || ''}
              dataKey={`UserName`}
              idKey={`UserID`}
              width="100%"
              onSelect={setSelectedUser}
              disabled={DashboardAccessLevel < 1}
            />
          </Item>
          <Item sx={sx.itemsx} className="input--container bookingDatePicker">
            <Datepicker
              name={'from_date'}
              label={`From Date`}
              id="fromDate"
              dateChange={(date) => {
                setFromDate(moment(date).format('YYYY-MM-DD'))
              }}
              startDate={'2024-01-01'}
              endDate={toDate}
              width="100%"
            />
          </Item>
          <Item sx={sx.itemsx} className="input--container bookingDatePicker">
            <Datepicker
              name={'to_date'}
              label={`To Date`}
              id="toDate"
              dateChange={(date) => {
                setToDate(moment(date).format('YYYY-MM-DD'))
              }}
              startDate={fromDate}
              endDate={moment().format('YYYY-MM-DD')}
              width="100%"
            />
          </Item>
          <Item id="generateDiv" tabIndex={0} sx={sx.itemsx}>
            <Button
              id="showDashBoard"
              variant="contained"
              className="btn btn-primary"
              autoFocus={false}
              onClick={(e) => {
                handleClick1()
              }}
              sx={{
                width: '100%',
                letterSpacing: '2px',
                height: '40px',
              }}
            >
              GO
            </Button>
          </Item>
          <Item sx={{ ...sx.itemsx, cursor: 'pointer' }} onClick={refreshData}>
            <RefreshSvg />
          </Item>
          <Item id="" tabIndex={0} sx={sx.itemsx}>
            <Button
              id=""
              variant="contained"
              className="btn btn-primary"
              autoFocus={false}
              onClick={handleBusinessAnalysis}
              sx={{
                width: '100%',
                letterSpacing: '2px',
                height: '40px',
              }}
            >
              Analysis
            </Button>
          </Item>
        </Box>
      </Item>
      <Item className="dashboard-body" sx={{ padding: '10px 15px' }}>
        <Item sx={{ padding: '0' }} className="dashboard-section">
          <Box className="dashboard-card flex">
            <Box className="info-box">
              <Box className="dashboard-info">
                {statusOverview.map((item, index) => (
                  <InfoCard
                    key={index}
                    startIcon={item.icon}
                    text1={statusOverviewValue[item.key]}
                    text2={item.label}
                    onArrowClick={() => {
                      const func = functionMap[item.key]
                      if (func) {
                        func() // Call the corresponding function
                      }
                    }}
                  />
                ))}
              </Box>
              <Box className="dashboard-info-title" style={{ fontSize: '14px', color: '#000', background: 'rgba(0, 134, 255, 0.04)' }}>
                Booking Overview
              </Box>
              <Box className="dashboard-info">
                {bookingOverview.map((item, index) => (
                  <InfoCard
                    key={index}
                    startIcon={item.icon}
                    text1={statusOverviewValue[item.key]}
                    text2={item.label}
                    onArrowClick={() => {
                      handleBkngDelOverview()
                    }}
                  />
                ))}
              </Box>
              <Box className="dashboard-info-title" style={{ fontSize: '14px', color: '#000', background: 'rgba(0, 134, 255, 0.04)' }}>
                Delivery Overview
              </Box>
              <Box className="dashboard-info">
                {deliveryOverview.map((item, index) => (
                  <InfoCard
                    key={index}
                    startIcon={item.icon}
                    text1={statusOverviewValue[item.key]}
                    text2={item.label}
                    onArrowClick={() => {
                      handleBkngDelOverview()
                    }}
                  />
                ))}
              </Box>
            </Box>
            <Box className="pie-chart">
              <CustomPieChart
                data={pieChartData.filter((item) => item.active)}
                bottomContent={<CustomLegend data={pieChartData} setData={setPieChartData} />}
                topContent={<PieTopSection />}
              />
            </Box>
          </Box>
        </Item>
        <Item sx={{ padding: '0' }} className="dashboard-section flex">
          <Box className="dashboard-card dashboard-box">
            <Item style={{ padding: '0', width: 'fit-content' }}>
              <SlidingToggle
                label1="top booking cities"
                label2="top delivery cities"
                externalActive={topCityButton}
                onChange={(id) => {
                  setTopCityButton(id)
                }}
              />
            </Item>
            <Item>
              <CustomBarChart
                data={topCityButton === 1 ? topBookingCityData : topDeliveryCityData}
                xdataKey="name"
                ydataKey="netAmount"
                ydataKey2="numberOfLrs"
                name2="Number of LRs"
              />
            </Item>
          </Box>
          <Box className="dashboard-card dashboard-box">
            <Item style={{ padding: '0', width: 'fit-content' }}>
              <SlidingToggle
                label1="top booking branches"
                label2="top delivery branches"
                externalActive={topBranchButton}
                onChange={(id) => {
                  setTopBranchButton(id)
                }}
              />
            </Item>
            <Item>
              <CustomBarChart
                data={topBranchButton === 1 ? topBookingBranchData : topDeliveryBranchData}
                xdataKey="name"
                ydataKey="netAmount"
                ydataKey2="numberOfLrs"
                name2="Number of LRs"
              />
            </Item>
          </Box>
        </Item>
        {[GUJRAT_COMPANY_ID, 1].includes(intCompanyID) ? (
          <Item sx={{ padding: '0' }} className="dashboard-section flex">
            <Box className="dashboard-card dashboard-box">
              <Item style={{ display: 'flex', alignItems: 'center', gap: '10px', justifyContent: 'space-between' }}>
                <Typography style={{ fontSize: '18px', color: '#000', fontWeight: 500 }}>Branchwise Target Achieved</Typography>
                <DropDownOA
                  label={`Select Month`}
                  data={monthListData}
                  defaultvalue={branchRevenueMonth?.monthName}
                  idKey={`monthVal`}
                  dataKey={`monthName`}
                  onSelect={(selectedMonth) => {
                    handleBranchMonthChange(selectedMonth)
                  }}
                  searchPlaceholder={`Search Month`}
                  isObjArr={true}
                  portal={true}
                />
              </Item>
              <Item>
                <TableContainer
                  style={{
                    borderRadius: '6px',
                    overflow: 'hidden',
                    border: '1px solid #ccc',
                    height: '335px',
                    display: 'block',
                    overflowY: 'scroll',
                  }}
                >
                  <Table>
                    <TableHead>
                      <TableRow>
                        {branchMonthlyBooking.map((item, index) => (
                          <TableCell
                            key={index + 's222s4'}
                            style={{
                              height: '35px',
                              position: 'sticky',
                              top: '0',
                              padding: '0 10px',
                              backgroundColor: '#CCE7FF',
                              fontWeight: 500,
                              fontSize: '12px',
                              color: '#444',
                              textAlign: item?.align,
                            }}
                          >
                            {item.headerName}
                          </TableCell>
                        ))}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {branchwiseMonthlyBookingData.map((a, index) => (
                        <TableRow key={index + '230sd'}>
                          {branchMonthlyBooking.map((item, index) => (
                            <TableCell
                              key={index + 's3d0'}
                              style={{
                                height: '30px',
                                padding: '0 10px',
                                fontWeight: 500,
                                fontSize: '12px',
                                color: '#444',
                                textAlign: item?.align,
                              }}
                            >
                              {a[item.key]}
                            </TableCell>
                          ))}
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Item>
            </Box>
            <Box className="dashboard-card dashboard-box">
              <Item style={{ display: 'flex', alignItems: 'center', gap: '10px', justifyContent: 'space-between' }}>
                <Typography style={{ fontSize: '18px', color: '#000', fontWeight: 500 }}>Party Wise Business</Typography>
                <DropDownOA
                  label={`Select Month`}
                  data={monthListData}
                  defaultvalue={partyRevenueMonth?.monthName}
                  idKey={`monthVal`}
                  dataKey={`monthName`}
                  onSelect={(selectedMonth) => {
                    handlePartyMonthChange(selectedMonth)
                  }}
                  searchPlaceholder={`Search Month`}
                  portal={true}
                />
              </Item>
              <Item>
                <TableContainer
                  style={{
                    borderRadius: '6px',
                    overflow: 'hidden',
                    border: '1px solid #ccc',
                    height: '335px',
                    display: 'block',
                    overflowY: 'scroll',
                  }}
                >
                  <Table>
                    <TableHead>
                      <TableRow>
                        {urls2.partyMonthlyBooking.map((item, index) => (
                          <TableCell
                            key={index + 's222s4'}
                            style={{
                              height: '35px',
                              position: 'sticky',
                              top: '0',
                              padding: '0 10px',
                              backgroundColor: '#CCE7FF',
                              fontWeight: 500,
                              fontSize: '12px',
                              color: '#444',
                              textAlign: item?.align,
                            }}
                          >
                            {item.headerName}
                          </TableCell>
                        ))}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {partyAllBookingData.map((a, index) => (
                        <TableRow key={index + '230sd'}>
                          {urls2.partyMonthlyBooking.map((item, index) => (
                            <TableCell
                              key={index + 's3d0'}
                              style={{
                                height: '30px',
                                padding: '0 10px',
                                fontWeight: 500,
                                fontSize: '12px',
                                color: '#444',
                                textAlign: item?.align,
                              }}
                            >
                              {a[item.key]}
                            </TableCell>
                          ))}
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Item>
            </Box>
          </Item>
        ) : null}

        <Item sx={{ padding: '0' }} className="dashboard-section flex">
          <Box className="dashboard-card dashboard-box">
            <Item style={{ display: 'flex', alignItems: 'center', gap: '10px', justifyContent: 'space-between' }}>
              <Typography style={{ fontSize: '18px', color: '#000', fontWeight: 500 }}>Sender Party Breakup</Typography>
            </Item>
            <Item>
              <Box className="flex">
                <CustomPieChart
                  data={partywiseSenderRevenueData.filter((item) => item.active)}
                  bottomContent={
                    <CustomLegend
                      data={partywiseSenderRevenueData.sort((a, b) => b.value - a.value)}
                      setData={setPartywiseSenderRevenueData}
                    />
                  }
                />
              </Box>
            </Item>
          </Box>
          <Box className="dashboard-card dashboard-box">
            <Item style={{ display: 'flex', alignItems: 'center', gap: '10px', justifyContent: 'space-between' }}>
              <Typography style={{ fontSize: '18px', color: '#000', fontWeight: 500 }}>Receiver Party Breakup</Typography>
            </Item>
            <Item>
              <Box className="flex">
                <CustomPieChart
                  data={partywiseReceiverRevenueData.filter((item) => item.active)}
                  bottomContent={
                    <CustomLegend
                      data={partywiseReceiverRevenueData.sort((a, b) => b.value - a.value)}
                      setData={setPartywiseReceiverRevenueData}
                    />
                  }
                />
              </Box>
            </Item>
          </Box>
        </Item>

        <Item sx={{ padding: '0' }} className="dashboard-section flex">
          <Box className="dashboard-card dashboard-box">
            <Item style={{ display: 'flex', alignItems: 'center', gap: '10px', justifyContent: 'space-between' }}>
              <Typography style={{ fontSize: '18px', color: '#000', fontWeight: 500 }}>Party Booking Data For Sender</Typography>
            </Item>
            <Item>
              <CustomBarChart
                data={partySenderBookingData}
                xdataKey="name"
                ydataKey="netAmount"
                ydataKey2="numberOfLrs"
                name1="Net Amount"
                name2="Number of LRs"
                color1="#E0A833"
                color2="#00689D"
              />
            </Item>
          </Box>
          <Box className="dashboard-card dashboard-box">
            <Item style={{ display: 'flex', alignItems: 'center', gap: '10px', justifyContent: 'space-between' }}>
              <Typography style={{ fontSize: '18px', color: '#000', fontWeight: 500 }}>Party Booking Data For Receiver</Typography>
            </Item>
            <Item>
              <CustomBarChart
                data={partyReceiverBookingData}
                xdataKey="name"
                ydataKey="netAmount"
                ydataKey2="numberOfLrs"
                name1="Net Amount"
                name2="Number of LRs"
                color1="#E0A833"
                color2="#00689D"
              />
            </Item>
          </Box>
        </Item>
        <Item sx={{ padding: '0' }} className="dashboard-section flex">
          <Box className="dashboard-card dashboard-box">
            <Item style={{ display: 'flex', alignItems: 'center', gap: '10px', justifyContent: 'space-between' }}>
              <Typography style={{ fontSize: '18px', color: '#000', fontWeight: 500 }}>Pending LR Report Last 7 Days</Typography>
            </Item>
            <Item>
              <CustomBarChart
                data={pending7DaysData}
                xdataKey="name"
                ydataKey="pendingDispatch"
                ydataKey2="pendingDelivery"
                ydataKey3="pendingReceive"
                showLine={false}
                noOfBars={3}
                name1="Pending Dispatch"
                name2="Pending Delivery"
                name3="Pending Receive"
                color1="#00689D"
                color2="#0086FF"
                color3="#E0A833"
                barGap={40}
              />
            </Item>
          </Box>
          <Box className="dashboard-card dashboard-box">
            <Item style={{ display: 'flex', alignItems: 'center', gap: '10px', justifyContent: 'space-between' }}>
              <Typography style={{ fontSize: '18px', color: '#000', fontWeight: 500 }}>Pending LR Report Last 30 Days</Typography>
            </Item>
            <Item>
              <CustomBarChart
                data={pending30DaysData}
                xdataKey="name"
                ydataKey="pendingDispatch"
                ydataKey2="pendingDelivery"
                ydataKey3="pendingReceive"
                showLine={false}
                noOfBars={3}
                name1="Pending Dispatch"
                name2="Pending Delivery"
                name3="Pending Receive"
                color1="#00689D"
                color2="#0086FF"
                color3="#E0A833"
                barGap={40}
              />
            </Item>
          </Box>
        </Item>
        <Item sx={{ padding: '0' }} className="dashboard-section flex">
          <Box className="dashboard-card dashboard-box">
            <Item style={{ display: 'flex', alignItems: 'center', gap: '10px', justifyContent: 'space-between' }}>
              <Typography style={{ fontSize: '18px', color: '#000', fontWeight: 500 }}>Revenue By Origin (Top 10 Cities)</Typography>
            </Item>
            <Item>
              <Box className="flex">
                <CustomPieChart
                  data={revenueByOriginData.filter((item) => item.active)}
                  bottomContent={
                    <CustomLegend data={revenueByOriginData.sort((a, b) => b.value - a.value)} setData={setRevenueByOriginData} />
                  }
                />
              </Box>
            </Item>
          </Box>
          <Box className="dashboard-card dashboard-box">
            <Item style={{ display: 'flex', alignItems: 'center', gap: '10px', justifyContent: 'space-between' }}>
              <Typography style={{ fontSize: '18px', color: '#000', fontWeight: 500 }}>Revenue By Destination (Top 10 Cities)</Typography>
            </Item>
            <Item>
              <Box className="flex">
                <CustomPieChart
                  data={revenueByDestinationData.filter((item) => item.active)}
                  bottomContent={
                    <CustomLegend data={revenueByDestinationData.sort((a, b) => b.value - a.value)} setData={setRevenueByDestinationData} />
                  }
                />
              </Box>
            </Item>
          </Box>
        </Item>
        <Item sx={{ padding: '0' }} className="dashboard-section flex">
          <Box className="dashboard-card dashboard-box">
            <Item style={{ display: 'flex', alignItems: 'center', gap: '10px', justifyContent: 'space-between' }}>
              <Typography style={{ fontSize: '18px', color: '#000', fontWeight: 500 }}>Userwise No. of Parcels (Top 10 Users)</Typography>
            </Item>
            <Item>
              <Box className="flex">
                <CustomPieChart
                  data={userNoOfParcelData.filter((item) => item.active)}
                  bottomContent={
                    <CustomLegend data={userNoOfParcelData.sort((a, b) => b.value - a.value)} setData={setUserNoOfParcelData} />
                  }
                />
              </Box>
            </Item>
          </Box>
          <Box className="dashboard-card dashboard-box">
            <Item style={{ display: 'flex', alignItems: 'center', gap: '10px', justifyContent: 'space-between' }}>
              <Typography style={{ fontSize: '18px', color: '#000', fontWeight: 500 }}>Userwise Total Revenue (Top 10 Users)</Typography>
            </Item>
            <Item>
              <Box className="flex">
                <CustomPieChart
                  data={userAllTotalData.filter((item) => item.active)}
                  bottomContent={<CustomLegend data={userAllTotalData.sort((a, b) => b.value - a.value)} setData={setUserAllTotalData} />}
                />
              </Box>
            </Item>
          </Box>
        </Item>
        <Item sx={{ padding: '0' }} className="dashboard-section flex">
          <Box className="dashboard-card dashboard-box">
            <Item style={{ display: 'flex', alignItems: 'center', gap: '10px', justifyContent: 'space-between' }}>
              <Typography style={{ fontSize: '18px', color: '#000', fontWeight: 500 }}>Datewise Revenue (Last 7 Days)</Typography>
            </Item>
            <Item>
              <CustomBarChart
                data={dateWiseRevenueData}
                xdataKey="name"
                ydataKey="dateWiseRevenueTotal"
                // ydataKey2="pendingDelivery"
                // ydataKey3="pendingReceive"
                showLine={false}
                noOfBars={3}
                name1="Date Wise Revenue"
                // name2="Pending Delivery"
                // name3="Pending Receive"
                color1="#00689D"
                color2="#0086FF"
                color3="#E0A833"
                barGap={40}
              />
            </Item>
          </Box>
          <Box className="dashboard-card dashboard-box">
            <Item style={{ display: 'flex', alignItems: 'center', gap: '10px', justifyContent: 'space-between' }}>
              <Typography style={{ fontSize: '18px', color: '#000', fontWeight: 500 }}>Datewise No of Parcels (Last 7 Days)</Typography>
            </Item>
            <Item>
              <CustomBarChart
                data={dateWiseNoOfParcelData}
                xdataKey="name"
                ydataKey="noOfParcel"
                // ydataKey2="pendingDelivery"
                // ydataKey3="pendingReceive"
                showLine={false}
                noOfBars={3}
                name1="No. Of Parcel"
                // name2="Pending Delivery"
                // name3="Pending Receive"
                color1="#00689D"
                color2="#0086FF"
                color3="#E0A833"
                barGap={40}
              />
            </Item>
          </Box>
        </Item>
        <Item sx={{ padding: '0' }} className="dashboard-section flex">
          <Box className="dashboard-card dashboard-box">
            <Item style={{ display: 'flex', alignItems: 'center', gap: '10px', justifyContent: 'space-between' }}>
              <Typography style={{ fontSize: '18px', color: '#000', fontWeight: 500 }}>Revenue per Hour (Last 12 Hours)</Typography>
            </Item>
            <Item>
              <CustomBarChart
                data={revenuePerHourData}
                xdataKey="name"
                ydataKey="revenuePerHour"
                // ydataKey2="pendingDelivery"
                // ydataKey3="pendingReceive"
                showLine={false}
                noOfBars={3}
                name1="Revenue Per Hour"
                // name2="Pending Delivery"
                // name3="Pending Receive"
                color1="#00689D"
                color2="#0086FF"
                color3="#E0A833"
                barGap={40}
              />
            </Item>
          </Box>
          <Box className="dashboard-card dashboard-box">
            <Item style={{ display: 'flex', alignItems: 'center', gap: '10px', justifyContent: 'space-between' }}>
              <Typography style={{ fontSize: '18px', color: '#000', fontWeight: 500 }}>Parcels per Hour (Last 12 Hours)</Typography>
            </Item>
            <Item>
              <CustomBarChart
                data={parcelPerHourData}
                xdataKey="name"
                ydataKey="parcelPerHour"
                // ydataKey2="pendingDelivery"
                // ydataKey3="pendingReceive"
                showLine={false}
                noOfBars={3}
                name1="Parcel Per Hour"
                // name2="Pending Delivery"
                // name3="Pending Receive"
                color1="#00689D"
                color2="#0086FF"
                color3="#E0A833"
                barGap={40}
              />
            </Item>
          </Box>
        </Item>
      </Item>
      {modal === 'deliveryOverview' && (
        <Modal headTxt={'Delivered LRs'} width="30%" updateModal={setModal} onClose={() => setModal('')}>
          <Stack direction="column" sx={{ padding: '15px 0px' }} className="booking-confirmation-section">
            <Box sx={{ width: '100%', padding: '12px 15px' }} className="sender-receiver">
              <Box className="sr-row">
                <Typography className="sr-label" sx={{ alignItems: 'left' }}>
                  Branch Name
                </Typography>
                :
                <Typography className="sr-value" sx={{ alignItems: 'left' }}>
                  {branch?.BranchName}
                </Typography>
              </Box>
              <TableContainer
                style={{ borderRadius: '6px', overflow: 'hidden', border: '1px solid #ccc', display: 'block', marginTop: '10px' }}
              >
                <Table>
                  <TableHead>
                    <TableRow>
                      {urls2.deliveredLrTable.map((item, index) => (
                        <TableCell
                          key={index + 's222s4'}
                          style={{
                            height: '35px',
                            position: 'sticky',
                            top: '0',
                            padding: '0 10px',
                            backgroundColor: '#CCE7FF',
                            fontWeight: 500,
                            fontSize: '12px',
                            color: '#444',
                            textAlign: item?.align,
                          }}
                        >
                          {item.headerName}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {paymentWiseDeliveryCount.map((a, index) => (
                      <TableRow key={index + '230sd'}>
                        {urls2.deliveredLrTable.map((item, index) => (
                          <TableCell
                            key={index + 's3d0'}
                            style={{
                              height: '30px',
                              padding: '0 10px',
                              fontWeight: 500,
                              fontSize: '12px',
                              color: '#444',
                              textAlign: item?.align,
                              backgroundColor: a.isTotal ? '#CCE7FF' : '#fff',
                            }}
                          >
                            {a[item.key]}
                          </TableCell>
                        ))}
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
            <Box sx={{ width: '100%', padding: '12px 15px' }}>
              <Button
                variant="contained"
                className="btn btn-primary"
                onClick={() => {
                  setModal('')
                }}
                sx={{
                  width: '100%',
                }}
              >
                OK
              </Button>
            </Box>
          </Stack>
        </Modal>
      )}
    </Item>
  )
}
